module.exports = __webpack_public_path__ + "static/media/cut-shitake.2ffef5b4.jpg";